package com.karyadina.cloudsync.service

import kotlinx.coroutines.flow.StateFlow

/**
 * Google Authentication Service interface
 * Handles OAuth token acquisition and refresh for Google Drive access
 */
interface GoogleAuthService {
    /**
     * Current authentication state
     */
    val authState: StateFlow<AuthState>
    
    /**
     * Authenticate user with Google
     * Opens native auth flow (platform-specific)
     */
    suspend fun authenticate(activity: Any? = null): Result<String>
    
    /**
     * Get valid OAuth token
     * Refreshes if expired
     */
    suspend fun getToken(): Result<String>
    
    /**
     * Logout user
     */
    suspend fun logout(): Result<Unit>
    
    /**
     * Check if user is authenticated
     */
    fun isAuthenticated(): Boolean
    
    /**
     * Get current user ID/email
     */
    fun getUserId(): String?
}

sealed class AuthState {
    object Unauthenticated : AuthState()
    object Authenticating : AuthState()
    data class Authenticated(val userId: String, val email: String) : AuthState()
    data class Error(val message: String) : AuthState()
}
